export const getXMLfromString = (xmlString) => {

	return new DOMParser().parseFromString(xmlString, 'text/xml');
}

export const getXMLNodes = (xmlDoc, tagName, metaName, metaValue) => {

	const nodes = Array.from(xmlDoc.getElementsByTagName(tagName));
	const filteredNodes = nodes.filter((node) => {

		return node.querySelector(metaName).textContent === metaValue;
	})

	return filteredNodes;
}

export const cleanXMLString = (text) => {

	let cleanXMLString = text.replace(/<item>(.*)<\/item>/gsm,'');
	cleanXMLString = cleanXMLString.replace(/<wp:term>(.*)<\/wp:term>/gsm,'');
	cleanXMLString = cleanXMLString.replace(/<wp:tag>(.*)<\/wp:tag>/gsm,'');
	cleanXMLString = cleanXMLString.replace(/<wp:category>(.*)<\/wp:category>/gsm,'');
	cleanXMLString = cleanXMLString.replace(/<wp:author>(.*)<\/wp:author>/gsm,'');

	return cleanXMLString;
}

export const insertXMLNode = (xmlDoc, parentNode, node) => (xmlDoc.getElementsByTagName(parentNode)[0].appendChild(node))

export const insertXMLNodes = (xmlDoc, parentNode, nodes) => {

	for (let node in nodes) {

		xmlDoc.getElementsByTagName(parentNode)[0].appendChild(nodes[node]);
	}

	return xmlDoc;
}

export const toggleAllFromList = (event, list, isSelected) => {

	const selection = Array.from(list.querySelectorAll('li'));

	for(let tickbox in selection) {

		if ( isSelected ) {

			selection[tickbox].classList.add('selected');
		} else {

			selection[tickbox].classList.remove('selected');
		}
	}
}

export const checkForChanges = (selectedItems, currentSelection) => {

	let hasChanges = false;

	if ( selectedItems.length !== currentSelection.length ) {

		hasChanges = true;
	} else {

		for (const item in currentSelection) {

			const id = currentSelection[item].getAttribute('data-id');
			if ( !selectedItems.includes(id) ) {

				hasChanges = true;
				break;
			}
		}
	}

	return hasChanges;
}
